import React, {useState} from "react";
import {adminGetPlatformVendors} from "../../../services/api/admin";
import ConfirmationModal from "../../Modal/ConfirmationModal";
import {Button, TextInput, Select} from "flowbite-react";
import {Search} from "react-feather";

const SearchAndUpdateVendorPlatformFlagBlock = ({handleFlagUpdate}) => {

    const [searchedVendors, setSearchedVendors] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearchVendorLoaded, setIsSearchVendorLoaded] = useState(true);
    const [selectedVendor, setSelectedVendor] = useState(null);
    const [selectedPlatform, setSelectedPlatform] = useState('sales_force');

    const searchVendorsByTerm = async () => {
        try {
            if (searchTerm.length === 0) {
                setSearchedVendors([]);
                return;
            }
            setIsSearchVendorLoaded(false)
            setSearchedVendors([]);
            const {data} = await adminGetPlatformVendors({
                term: searchTerm,
                page: 1,
                per_page: 10,
                has_platform: 0
            });
            setIsSearchVendorLoaded(true);
            setSearchedVendors(data);
        } catch (e) {
            setIsSearchVendorLoaded(true);
            console.error('Error fetching vendors:', e);
        }
    }

    const handleConfirm = async () => {
        try {
            await handleFlagUpdate(selectedVendor.id, true, selectedPlatform);
            setSelectedVendor(null);
            setSearchTerm('');
            setSelectedPlatform('sales_force');
        } catch (e) {
            setSelectedVendor(null);
            setSearchTerm('');
            setSelectedPlatform('sales_force');
        }
    }

    React.useEffect(() => {
            searchVendorsByTerm().then(r => console.log('r', r));
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [searchTerm])

    return <div className={"sl-flex sl-flex-row sl-justify-center"}>

        {selectedVendor && <ConfirmationModal
            title={selectedVendor.name}
            message={
                <div className="sl-flex sl-flex-col sl-gap-4">
                    <p>Select platform feature to add for this Vendor</p>
                    <div className="sl-flex sl-flex-col sl-gap-2">
                        <label className="sl-text-sm sl-font-medium">Select Platform:</label>
                        <Select
                            value={selectedPlatform}
                            onChange={(e) => setSelectedPlatform(e.target.value)}
                            className="sl-w-full"
                        >
                            <option 
                                value="sales_force" 
                                disabled={selectedVendor.platforms && selectedVendor.platforms.includes('sales_force')}
                            >
                                Sales Force {selectedVendor.platforms && selectedVendor.platforms.includes('sales_force') ? '(Already Enabled)' : ''}
                            </option>
                            <option 
                                value="hubspot" 
                                disabled={selectedVendor.platforms && selectedVendor.platforms.includes('hubspot')}
                            >
                                HubSpot {selectedVendor.platforms && selectedVendor.platforms.includes('hubspot') ? '(Already Enabled)' : ''}
                            </option>
                        </Select>
                    </div>
                </div>
            }
            handleConfirm={handleConfirm}
            handleClose={() => {
                setSelectedVendor(null);
                setSelectedPlatform('sales_force');
            }}
        />}

        <div
            className={"sl-border-1 sl-bg-gray-200 sl-border-solid sl-border-radius-8 sl-border-gray-200 sl-p-4 sl-mb-4 sl-flex sl-flex-col sl-w-120"}>
            <span className={"sl-text-md sl-p-2"}>Manage platform availability for vendors</span>
            <div className={"sl-flex sl-flex-row relative"}>

                <TextInput
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value)
                    }}
                    isProcessing={isSearchVendorLoaded}
                    className={"sl-w-92"}
                    type="text" sizing="md" placeholder={'Enter Vendor name'}/>

                {searchedVendors.length > 0 && <div
                    className={"sl-absolute sl-bg-white sl-top-12 sl-border-radius-8 sl-z-10 sl-shadow-sm sl-w-fill-available "}>
                    <div className={"sl-flex sl-flex-col"}>
                        {searchedVendors.map((vendor) => (
                            <div
                                onClick={() => setSelectedVendor(vendor)}
                                className={"sl-hover-gray-50 sl-cursor-pointer sl-p-2 sl-border-b-1 sl-border-solid sl-border-gray-200"}>
                                {vendor.name}
                            </div>))}
                    </div>
                </div>}

                <div style={{width: '30px', marginLeft: '10px'}}>
                    <Button size="md" isProcessing={!isSearchVendorLoaded} onClick={searchVendorsByTerm}
                            className={"sl-h-10"}
                            color={"light"}>
                        {isSearchVendorLoaded && <Search size={16}/>}
                    </Button>
                </div>
            </div>
        </div>
    </div>

}

export default SearchAndUpdateVendorPlatformFlagBlock;
